export default __webpack_public_path__ + "static/media/1.2c4acd2f.jpg";